
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  provide,
  ref,
} from "vue";
import VueInputGroup from "@/global-components/form-elements/input-group/Main.vue";
import VueTextarea from "@/global-components/form-elements/textarea/Main.vue";
import Dropzone from "@/global-components/dropzone/Main.vue";
import { DropzoneFile, DropzoneOptions } from "dropzone";
import {
  GetBallot,
  GetDocument,
  BallotComment,
  GetBallotCommentResult,
  ballotCommentService,
} from "@/services";
import { useStore } from "@/store";
import { useGeneralActions } from "@/utils/actions";
import { GeneralCreateOrUpdate } from "@/utils/actions/create-or-update";

interface CreateOrUpdate extends GeneralCreateOrUpdate {
  formData: BallotComment;
}

export default defineComponent({
  name: "WriteComment",
  components: { Dropzone, VueTextarea, VueInputGroup },
  props: {
    ballot: {
      type: Object as () => GetBallot,
      default: () => ({}),
    },
    canComment: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { fetchRecord, createOrUpdate } = useGeneralActions();

    const refCommentModal = ref<HTMLElement>();
    const dropzoneRef = ref<HTMLElement>();
    provide("bind[dropzoneRef]", (el: HTMLElement) => {
      dropzoneRef.value = el;
    });

    const { loading, data, fetch } = fetchRecord({
      fetchApiMethod: ballotCommentService.show,
      successCallback: () => {
        setFormData({
          text: _.get(data.value, "0.text", ""),
          files: _.get(data.value, "0.files", []),
        });
        setTimeout(() => manualAddDocuments(formData.files), 100);
      },
    });

    const {
      processing,
      formData,
      validationErrors,
      submit,
      setFormData,
    } = createOrUpdate({
      createApiMethod: async (params) => {
        return await ballotCommentService.store(props.ballot.id, params);
      },
      successCallback(result: GetBallotCommentResult) {
        if (result.kind === "ok") {
          emit("update:created-comment", result.data);
          closeModal();
        }
      },
      params: {
        ballot_id: props.ballot.id,
        user_id: _.get(store.state.auth, "profile.id", ""),
        text: "",
        files: [],
      },
    }) as CreateOrUpdate;

    // const committeeFolder = computed<any>(() => {
    //   return store.getters["document/getFolderByType"](
    //     props.ballot.committee_id,
    //     "ballot"
    //   );
    // });

    const dropzoneOptions = computed<DropzoneOptions>(() => {
      return {
        // acceptedFiles:
        //   "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        params: {
          committee_id: props.ballot.committee_id,
          resource_type: "ballot",
          resource_id: props.ballot.id,
          // folder_id: committeeFolder.value?.id || null,
          type: 610,
        },
      };
    });

    const onSubmit = () => submit();
    const openModal = () => {
      fetch(props.ballot.id);
      cash("#comment-modal").modal("show");
    };
    const closeModal = () => {
      cash("#comment-modal").modal("hide");
    };

    const successUploadFile = (document: GetDocument) => {
      formData.files.push({
        id: document.id,
        uuid: document.uuid,
        title: document.title,
        n_number: document.n_number,
        file_name: document.file_name,
        file_size: document.file_size,
      });
    };

    const removeUploadedFile = (uuid: string) => {
      const fileIndex = _.findIndex(formData.files, { uuid });
      if (fileIndex > -1) formData.files.splice(fileIndex, 1);
    };

    const manualAddDocuments = (documents: Record<string, any>[]) => {
      documents.map((document: Record<string, any>) => {
        const mockFile: Record<string, any> = {
          accepted: true,
          name: document.file_name || "",
          size: document.file_size,
          processing: true,
          status: "success",
          documentUuid: document.uuid,
          documentId: document.id,
        };
        dropzoneRef.value?.dropzone.files.push(mockFile as DropzoneFile);
        dropzoneRef.value?.dropzone.emit("addedfile", mockFile);
        dropzoneRef.value?.dropzone.emit("complete", mockFile);
      });
    };

    onMounted(() => {
      cash("#comment-modal").modal("on.hide", () => {
        formData.text = "";
        formData.files = [];
      });
    });

    onBeforeUnmount(() => {
      cash(refCommentModal.value || "#comment-modal").modal("hide");
    });

    return {
      loading,
      processing,
      formData,
      validationErrors,
      dropzoneOptions,
      refCommentModal,
      dropzoneRef,
      onSubmit,
      openModal,
      closeModal,
      successUploadFile,
      removeUploadedFile,
    };
  },
});
